import { Component, Input, OnInit } from '@angular/core';
import { Faq } from 'src/app/interfaces/contentful/faq';
import { ContentfulService } from 'src/app/services/contentful.service';

@Component({
  selector: 'app-faqs-component',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  @Input() contentId = '';

  public content: Faq | undefined;
  public error: string | undefined;

  constructor(private contentfulService: ContentfulService) { }

  ngOnInit(): void {

    if (!this.content) {
      this.contentfulService.getContentItem(this.contentId)
      .then(content => {
        console.log(`[FAQs Component] Contentful returned the folowing for ID: ${this.contentId}`, content)
        this.content = content.fields;
      })
      .catch(error => {
        this.error = "Error: content could not be loaded."
      })
    }
  }

}
